(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
          const productRecommendations = document.getElementById('Cart-Recommendations');

          if (!productRecommendations) {
            return;
          }

          const recommendationsSectionId = 'cart-product-recommendations';

          // Load initial product recommendations
          loadCartRecommendations();

          // Listen for product card add to cart event so recommendations can be updated
          document.body.addEventListener('productCard:addToCart:sections', (evt) => {
            const { detail } = evt;
            
            if (detail?.sections?.[recommendationsSectionId]) {
              updateCartRecommendationsHtml(detail.sections[recommendationsSectionId]);
            }
          });

          // Listen for cart changes so if the first cart product changes, new recommended products can be served
          document.body.addEventListener('cart:changed', (evt) => {
            const { detail } = evt;

            if (detail?.cart) {
              const currProductId = productRecommendations.getAttribute('data-product-id');
              const nextProductId = detail.cart.items[0]?.product_id ?? null;

              if (currProductId !== nextProductId) {
                productRecommendations.setAttribute('data-product-id', nextProductId);
                loadCartRecommendations(nextProductId);
              }
            }
          });

          function loadCartRecommendations(productId = undefined, intent = 'related') {
            const productRecommendationsId = 'undefined' !== typeof productId ? productId : productRecommendations.getAttribute('data-product-id');
            const recommendationsUrl = productRecommendations.getAttribute('data-recommend-url');

            if (!recommendationsUrl || !productRecommendationsId) {
              productRecommendations.hidden = true;
              return;
            }

            const recommendationsParams = new URLSearchParams();

            recommendationsParams.append('product_id', productRecommendationsId);
            recommendationsParams.append('limit', '4');
            recommendationsParams.append('section_id', recommendationsSectionId);
            recommendationsParams.append('intent', intent || 'related');

            return fetch(`${recommendationsUrl}?${recommendationsParams.toString()}`)
              .then(response => response.text())
              .then((text) => {
                updateCartRecommendationsHtml(text);
              });
          }

          function updateCartRecommendationsHtml(html) {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const recommendations = temp.querySelector('#Cart-Recommendations-Section');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendations.innerHTML = recommendations.innerHTML;

              const cards = productRecommendations.querySelectorAll('[data-js="product-card"]');

              if (cards.length > 0 && 'function' === typeof window.mountProductCard) {
                cards.forEach(window.mountProductCard);
              }
            }
          }
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
